<template>
  <div class="flex flex-col p-2 gap-2">
    <div v-if="wait">
      <Spinner
        message="Loading..."
        :size="6"
      />
    </div>
    <div v-else>
      <div class="flex flex-row gap-2"
        v-if="existsSyncData">
        <Button
          color="blue"
          size="md"
          :disabled="!enableItems"
          @click="toggleItems">
          {{ viewItemsDisplay }}
        </Button>
        <Button
          color="blue"
          size="md"
          :disabled="!enableLogs"
          @click="toggleLogs">
          {{ viewLogsDisplay }}
        </Button>
        <Button
          color="blue"
          size="md"
          :disabled="!enableErrors"
          @click="toggleErrors">
          {{ viewErrorsDisplay }}
        </Button>
      </div>
      <div class="flex flex-col gap-2"
        v-if="existsSyncData">
        <SyncStepItems
          v-if="viewItems"
          :items="items"
        />
        <SyncStepLogs
          v-if="viewLogs"
          :logs="logs"
        />
        <SyncStepErrors
          v-if="viewErrors"
          :errors="errors"
        />
      </div>
      <div class="px-2"
        v-if="!existsSyncData">
        <span class="text-gray-400 font-italics">No Sync Data</span>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'

import Button from '../../Button.vue'
import Spinner from '../../Spinner.vue'
// import XButton from '../../XButton.vue'

import SyncStepItems from './SyncStepItems.vue'
import SyncStepLogs from './SyncStepLogs.vue'
import SyncStepErrors from './SyncStepErrors.vue'

export default {
  components: {
    Button,
    Spinner,
    SyncStepItems,
    SyncStepLogs,
    SyncStepErrors,
  },
  props: {
    syncIds: {
      type: Array,
      default: undefined,
    },
    wait: Boolean,
  },
  data() {
    return {
      viewErrors: false,
      viewLogs: false,
      viewItems: false,

      errors: [],
      logs: [],
      items: [],
    }
  },
  methods: {
    init() {
      // do nothing
    },
    toggleErrors() {
      this.viewErrors = !this.viewErrors
    },
    toggleLogs() {
      this.viewLogs = !this.viewLogs
    },
    toggleItems() {
      this.viewItems = !this.viewItems
    },
  },
  computed: {
    existsSyncData() {
      return !isEmpty(this.syncIds)
    },
    enableErrors() {
      return !this.errors || !isEmpty(this.errors)
    },
    enableLogs() {
      return !this.logs || !isEmpty(this.logs)
    },
    enableItems() {
      return !this.items || !isEmpty(this.items)
    },
    viewErrorsDisplay() {
      return (this.enableErrors)
        ? (this.viewErrors) ? 'Close Errors' : 'View Errors'
        : 'No Errors'
    },
    viewLogsDisplay() {
      return (this.enableLogs)
        ? (this.viewLogs) ? 'Close Logs' : 'View Logs'
        : 'No Logs'
    },
    viewItemsDisplay() {
      return (this.enableItems)
        ? (this.viewItems) ? 'Close Items' : 'View Items'
        : 'No Items'
    },
  },
  mounted() {
    if (this.wait) {
      return
    }

    this.init()
  },
  watch: {
    wait(newValue) {
      if (!newValue) {
        this.init()
      }
    },
  },
}
</script>
